export type URLSearchValue = string | boolean | number | undefined;
export type URLSearchInput<T> = { [P in keyof T]: URLSearchValue | URLSearchValue[] };

export const objectToQueryString = <T>(object: URLSearchInput<T>): string =>
  Object.entries(object)
    .filter(([key]) => encodeURIComponent(key) !== '')
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const values = Array.isArray(value) ? value : [value];

      return values
        .filter((value) => value !== undefined && value !== '')
        .map((value) => `${encodedKey}=${encodeURIComponent(value as string)}`)
        .join('&');
    })
    .filter((value) => value.length > 0)
    .join('&');

export const slugifyString = (source: string, maxLength?: number): string => {
  source = source.replace(/['"‘“”’]/g, '');
  source = source.replace(/[^a-z0-9]+/gi, '-');
  source = source.replace(/-{2,}/g, '-');
  source = source.replace(/^-+/g, '');
  source = source.replace(/-+$/g, '');
  source = source.toLowerCase();

  return maxLength !== undefined ? source.slice(0, maxLength).replace(/-$/, '') : source;
};

export const slugifyPath = (source: string, maxSlugLength?: number): string => {
  return source
    .split('/')
    .map((slug) => slugifyString(slug, maxSlugLength))
    .join('/');
};
